<template>
  <el-dialog :title="title"
             :close-on-click-modal="false"
             width="650px"
             @closed="close"
             :visible.sync="visible">
    <el-form ref="form"
             :model="form"
             :rules="formRules"
             size="medium"
             label-width="140px"
             @submit.native.prevent="onSubmit()">
      <div class="re-el-form__flex">
        <div class="medium">
          <el-form-item label="岗位名称"
                        prop="name"
                        clearable>
            <el-input v-model="form.name"
                      placeholder="请输入岗位名称" />
          </el-form-item>
        </div>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
       <el-button @click="close()"> 取消 </el-button>
        <el-button type="primary"
                   @click="onSubmit()"> 提交
        </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { departmentJobFormRules as formRules } from '../finance-config.rules.js'

export default {
  props: {
    params: {
      type: Object,
      default: {
        department_id: null
      }
    }
  },
  data () {
    return {
      visible: false,
      formRules,
      form: {
        id: null,
        department_id: this.department_id,
        name: ''
      }
    }
  },
  mounted () {
    this.resetData()
  },
  computed: {
    title () {
      return this.form.id ? '修改部门岗位' : '创建部门岗位'
    }
  },
  methods: {
    resetData () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.form.department_id = this.params.department_id
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.form.id ? this.update(this.form) : this.create(this.form)
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    create (data) {
      request.common('createDepartmentJob', data).then(({data}) => {
        this.$message.success(this.title + '成功')
        this.$emit('submitted')
        this.close()
      })
    },
    update (data) {
      request.common('updateDepartmentJob', data).then(({data}) => {
        this.$message.success(this.title + '成功')
        this.$emit('submitted')
        this.close()
      })
    },
    show (id) {
      this.visible = true

      if (id) {
        this.form.id = id
        request.common('getDepartmentJobDetail', {id}).then(({data}) => {
          filter.setLoop(this.form, data)
        })
      }
    },
    close () {
      this.resetData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/finance-config/components/FinanceDepartmentJobFormDialog.vue